<button
  type="button"
  class="btn btn-link popOver"
  [class.warning]="type === 'warning'"
  container="body"
  popoverClass="dcPopover"
  #p="ngbPopover"
  [ngbPopover]="popContent"
  [triggers]="trigger ? trigger : 'manual'"
  (click)="click()"
  [title]="label ? label : ''"
  [popoverTitle]="label ? label : null"
></button>
<ng-template #popContent>
  <div [innerHtml]="body"></div>
</ng-template>
